var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3689 11.1089C20.3698 10.4275 20.3117 9.74726 20.1955 9.07568H10.6997V12.9269H16.1385C16.0272 13.542 15.7916 14.1283 15.446 14.6506C15.1004 15.1728 14.6518 15.6202 14.1274 15.9656V18.4655H17.3733C19.2739 16.7253 20.3689 14.1518 20.3689 11.1089Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6997 20.8809C13.4169 20.8809 15.7049 19.9948 17.3733 18.4671L14.1274 15.9672C13.2239 16.5755 12.0604 16.9227 10.6997 16.9227C8.07328 16.9227 5.84408 15.1645 5.04693 12.7952H1.70312V15.3714C2.5412 17.0276 3.82629 18.4198 5.41494 19.3927C7.00358 20.3655 8.83324 20.8808 10.6997 20.8809Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04686 12.7948C4.62543 11.5533 4.62543 10.2088 5.04686 8.96725V6.39099H1.70305C0.998032 7.78419 0.630859 9.32182 0.630859 10.881C0.630859 12.4403 0.998032 13.9779 1.70305 15.3711L5.04686 12.7948Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6997 4.83965C12.1356 4.81635 13.5231 5.35515 14.5623 6.33957L17.4362 3.48555C15.6139 1.78574 13.1996 0.852518 10.6997 0.881515C8.83324 0.8816 7.00358 1.39684 5.41494 2.36972C3.82629 3.3426 2.5412 4.73482 1.70312 6.39096L5.04693 8.96722C5.84408 6.5979 8.07328 4.83965 10.6997 4.83965Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGgIcon);
export default __webpack_public_path__ + "static/media/gg-icon.d253340fc3536628245aa1673adb40a8.svg";
export { ForwardRef as ReactComponent };